// Dashboard-level APIs for Project Development
// Currently uses static responses / console logs; replace with real axios when backend is ready.

import axios from 'axios';
import { appUrl } from '../../../../../../utils/config';
import { getApiBaseUrl } from '../../CommonMethods/CommonMethods';
import { USE_STATIC_PD_DATA } from '../ProjectTabs/tabDataAPI';

// ===== API FUNCTIONS =====

// Static data for dashboard — sourced from BMS_Data_Final_27032026.xlsx
const getStaticProjects = () => {
  return [
    {
      id: 1,
      cmoSite: "Sai Life Sciences - Unit-IV",
      projectId: "1462139 - LTSS - BSQ",
      productDescription: "BMT-811890-01",
      poNumber: "18219",
      campaignId: "CMPO04BRS729",
      cmoStage: "Stage A, B, C, D, E",
      cmoBatchNumber: "DBSQA25001, DBSQA25002, DBSQA25003, DBSQA25004, DBSQA25005, DBSQA25006, DBSQA25007, DBSQA25008",
      deliverableType: "Manufacturing",
      projectStatus: "Completed",
      campaignStatus: "Completed",
      completionDate: "2026-06-30",
      projectDetails: {
        campaigns: [
          {
            campaignId: "CMPO04BRS729",
            campaignID: "CMPO04BRS729",
            collabrixCampaignID: 1,
            campaignStatus: "Completed",
            stages: [
              {
                stageId: "Stage A",
                stageName: "Stage A (MIR-037812-01)",
                batches: [
                  { batchNumber: "DBSQA25001", batchId: "DBSQA25001" },
                  { batchNumber: "DBSQA25002", batchId: "DBSQA25002" },
                  { batchNumber: "DBSQA25003", batchId: "DBSQA25003" },
                  { batchNumber: "DBSQA25004", batchId: "DBSQA25004" },
                  { batchNumber: "DBSQA25005", batchId: "DBSQA25005" },
                  { batchNumber: "DBSQA25006", batchId: "DBSQA25006" },
                  { batchNumber: "DBSQA25007", batchId: "DBSQA25007" },
                  { batchNumber: "DBSQA25008", batchId: "DBSQA25008" },
                ],
              },
              {
                stageId: "Stage B",
                stageName: "Stage B (BMT-986213/BMT-916214)",
                batches: [
                  { batchNumber: "DBSQB25001", batchId: "DBSQB25001" },
                  { batchNumber: "DBSQB25002", batchId: "DBSQB25002" },
                  { batchNumber: "DBSQB25003", batchId: "DBSQB25003" },
                  { batchNumber: "DBSQB25004", batchId: "DBSQB25004" },
                  { batchNumber: "DBSQB25005", batchId: "DBSQB25005" },
                  { batchNumber: "DBSQB25006", batchId: "DBSQB25006" },
                  { batchNumber: "DBSQB25007", batchId: "DBSQB25007" },
                  { batchNumber: "DBSQB25008", batchId: "DBSQB25008" },
                  { batchNumber: "DBSQB25009", batchId: "DBSQB25009" },
                ],
              },
              {
                stageId: "Stage C",
                stageName: "Stage C (MIR-006432-01)",
                batches: [
                  { batchNumber: "DBSQC25001", batchId: "DBSQC25001" },
                  { batchNumber: "DBSQC26001", batchId: "DBSQC26001" },
                  { batchNumber: "DBSQC26002", batchId: "DBSQC26002" },
                  { batchNumber: "DBSQC26003", batchId: "DBSQC26003" },
                  { batchNumber: "DBSQC26004", batchId: "DBSQC26004" },
                  { batchNumber: "DBSQC26005", batchId: "DBSQC26005" },
                  { batchNumber: "DBSQC26006", batchId: "DBSQC26006" },
                  { batchNumber: "DBSQC26007", batchId: "DBSQC26007" },
                  { batchNumber: "DBSQC26008", batchId: "DBSQC26008" },
                  { batchNumber: "DBSQC26009", batchId: "DBSQC26009" },
                  { batchNumber: "DBSQC26010", batchId: "DBSQC26010" },
                  { batchNumber: "DBSQC26011", batchId: "DBSQC26011" },
                  { batchNumber: "DBSQC26012", batchId: "DBSQC26012" },
                ],
              },
              {
                stageId: "Stage D",
                stageName: "Stage D (MIR-037058-01)",
                batches: [
                  { batchNumber: "DBSQD26001", batchId: "DBSQD26001" },
                  { batchNumber: "DBSQD26002", batchId: "DBSQD26002" },
                  { batchNumber: "DBSQD26003", batchId: "DBSQD26003" },
                  { batchNumber: "DBSQD26004", batchId: "DBSQD26004" },
                  { batchNumber: "DBSQD26005", batchId: "DBSQD26005" },
                  { batchNumber: "DBSQD26006", batchId: "DBSQD26006" },
                  { batchNumber: "DBSQD26007", batchId: "DBSQD26007" },
                  { batchNumber: "DBSQD26008", batchId: "DBSQD26008" },
                  { batchNumber: "DBSQD26009", batchId: "DBSQD26009" },
                ],
              },
              {
                stageId: "Stage E",
                stageName: "Stage E (BMT-811890-01)",
                batches: [
                  { batchNumber: "DBSQE26001", batchId: "DBSQE26001" },
                  { batchNumber: "DBSQE26002", batchId: "DBSQE26002" },
                  { batchNumber: "DBSQE26003", batchId: "DBSQE26003" },
                  { batchNumber: "DBSQE26004", batchId: "DBSQE26004" },
                  { batchNumber: "DBSQE26005", batchId: "DBSQE26005" },
                  { batchNumber: "DBSQE26006", batchId: "DBSQE26006" },
                  { batchNumber: "DBSQE26007", batchId: "DBSQE26007" },
                  { batchNumber: "DBSQE26008", batchId: "DBSQE26008" },
                  { batchNumber: "DBSQE26009", batchId: "DBSQE26009" },
                ],
              },
            ],
          },
        ],
      },
    },
    {
      id: 2,
      cmoSite: "Unit-IV",
      projectId: "1484812 - Clinical Supply - BQC",
      productDescription: "BMS-986506-02",
      poNumber: "18473",
      campaignId: "CMPO04BRS747",
      cmoStage: "Stage A",
      cmoBatchNumber: "DBQCA26001, DBQCA26002",
      deliverableType: "Manufacturing",
      projectStatus: "In-Progress",
      campaignStatus: "In-Progress",
      completionDate: "",
      projectDetails: {
        campaigns: [
          {
            campaignId: "CMPO04BRS747",
            campaignID: "CMPO04BRS747",
            collabrixCampaignID: 2,
            campaignStatus: "In-Progress",
            stages: [
              {
                stageId: "Stage A",
                stageName: "Stage A (BMT-902167-01)",
                batches: [
                  { batchNumber: "DBQCA26001", batchId: "DBQCA26001" },
                  { batchNumber: "DBQCA26002", batchId: "DBQCA26002" },
                ],
              },
            ],
          },
        ],
      },
    },
    {
      id: 3,
      cmoSite: "Unit-IV",
      projectId: "1453915 - Clinical Supply - BSR",
      productDescription: "BMS-986482-02",
      poNumber: "17933",
      campaignId: "CMPO04BRS707",
      cmoStage: "Stage A, Stage B, Stage C, Stage D, Stage E",
      cmoBatchNumber: "DBSRA25001, DBSRA25002",
      deliverableType: "Manufacturing",
      projectStatus: "In-Progress",
      campaignStatus: "In-Progress",
      completionDate: "",
      projectDetails: {
        campaigns: [
          {
            campaignId: "CMPO04BRS707",
            campaignID: "CMPO04BRS707",
            collabrixCampaignID: 3,
            campaignStatus: "In-Progress",
            stages: [
              {
                stageId: "Stage A",
                stageName: "Stage A (BMS-796258-01)",
                batches: [
                  { batchNumber: "DBSRA25001", batchId: "DBSRA25001" },
                  { batchNumber: "DBSRA25002", batchId: "DBSRA25002" },
                ],
              },
              {
                stageId: "Stage B",
                stageName: "Stage B (BMT-813536-01)",
                batches: [
                  { batchNumber: "DBSRB25001", batchId: "DBSRB25001" },
                  { batchNumber: "DBSRB25002", batchId: "DBSRB25002" },
                ],
              },
              {
                stageId: "Stage C",
                stageName: "Stage C (BMT-854872-01)",
                batches: [
                  { batchNumber: "DBSRC25001", batchId: "DBSRC25001" },
                  { batchNumber: "DBSRC25002", batchId: "DBSRC25002" },
                ],
              },
              {
                stageId: "Stage D",
                stageName: "Stage D (BMT-854873-01)",
                batches: [
                  { batchNumber: "DBSRD25001", batchId: "DBSRD25001" },
                  { batchNumber: "DBSRD25002", batchId: "DBSRD25002" },
                ],
              },
              {
                stageId: "Stage E",
                stageName: "Stage E (BMS-986482-02)",
                batches: [
                  { batchNumber: "DBSRE25001", batchId: "DBSRE25001" },
                  { batchNumber: "DBSRE25002", batchId: "DBSRE25002" },
                  { batchNumber: "DBSRE25003", batchId: "DBSRE25003" },
                ],
              },
            ],
          },
        ],
      },
    },
    {
      id: 4,
      cmoSite: "Unit-IV",
      projectId: "1453915 - Clinical Supply - BSR",
      productDescription: "BMS-986482-02",
      poNumber: "18031",
      campaignId: "CMPO04BRS715",
      cmoStage: "Stage E",
      cmoBatchNumber: "DBSRE25003, DBSRE26001, DBSRE26002",
      deliverableType: "Manufacturing",
      projectStatus: "In-Progress",
      campaignStatus: "In-Progress",
      completionDate: "",
      projectDetails: {
        campaigns: [
          {
            campaignId: "CMPO04BRS715",
            campaignID: "CMPO04BRS715",
            collabrixCampaignID: 4,
            campaignStatus: "In-Progress",
            stages: [
              {
                stageId: "Stage E",
                stageName: "Stage E (BMS-986482-02)",
                batches: [
                  { batchNumber: "DBSRE25003", batchId: "DBSRE25003" },
                  { batchNumber: "DBSRE26001", batchId: "DBSRE26001" },
                  { batchNumber: "DBSRE26002", batchId: "DBSRE26002" },
                ],
              },
            ],
          },
        ],
      },
    },
    {
      id: 5,
      cmoSite: "Unit-IV",
      projectId: "1463268 - Clinical Supply - BST",
      productDescription: "BMS-986523-01",
      poNumber: "18120",
      campaignId: "CMPO04BRS725",
      cmoStage: "Stage A, Stage B, Stage C, Stage D, Stage E",
      cmoBatchNumber: "DBSTA25001, DBSTA25002, DBSTA25003, DBSTA25004",
      deliverableType: "Manufacturing",
      projectStatus: "In-Progress",
      campaignStatus: "In-Progress",
      completionDate: "",
      projectDetails: {
        campaigns: [
          {
            campaignId: "CMPO04BRS725",
            campaignID: "CMPO04BRS725",
            collabrixCampaignID: 5,
            campaignStatus: "In-Progress",
            stages: [
              {
                stageId: "Stage A",
                stageName: "Stage A (BMT-933279)",
                batches: [
                  { batchNumber: "DBSTA25001", batchId: "DBSTA25001" },
                  { batchNumber: "DBSTA25002", batchId: "DBSTA25002" },
                  { batchNumber: "DBSTA25003", batchId: "DBSTA25003" },
                  { batchNumber: "DBSTA25004", batchId: "DBSTA25004" },
                ],
              },
              {
                stageId: "Stage C",
                stageName: "Stage C (INA-002584)",
                batches: [
                  { batchNumber: "DBSTC25001", batchId: "DBSTC25001" },
                  { batchNumber: "DBSTC25002", batchId: "DBSTC25002" },
                ],
              },
              {
                stageId: "Stage D",
                stageName: "Stage D (BMT-933280)",
                batches: [
                  { batchNumber: "DBSTD25001", batchId: "DBSTD25001" },
                  { batchNumber: "DBSTD25002", batchId: "DBSTD25002" },
                  { batchNumber: "DBSTD25003", batchId: "DBSTD25003" },
                ],
              },
              {
                stageId: "Stage E",
                stageName: "Stage E (BMS-986523-01)",
                batches: [
                  { batchNumber: "DBSTE26001", batchId: "DBSTE26001" },
                  { batchNumber: "DBSTE26002", batchId: "DBSTE26002" },
                ],
              },
              {
                stageId: "Stage B",
                stageName: "Stage B (BMT-909920-02)",
                batches: [
                  { batchNumber: "DBSUB25001", batchId: "DBSUB25001" },
                  { batchNumber: "DBSUB25002", batchId: "DBSUB25002" },
                ],
              },
            ],
          },
        ],
      },
    },
    {
      id: 6,
      cmoSite: "Unit-IV",
      projectId: "1462139 - LTSS - BSZ",
      productDescription: "BMT-897624",
      poNumber: "18339",
      campaignId: "CMPO04BRS727",
      cmoStage: "Stage A, Stage B, Stage C, Stage D",
      cmoBatchNumber: "DBSZA25001, DBSZA25002, DBSZA26001, DBSZA26002, DBSZA26003, DBSZA26004, DBSZA26005, DBSZA26006, DBSZA26007, DBSZA26008, DBSZA26009",
      deliverableType: "Manufacturing",
      projectStatus: "In-Progress",
      campaignStatus: "In-Progress",
      completionDate: "",
      projectDetails: {
        campaigns: [
          {
            campaignId: "CMPO04BRS727",
            campaignID: "CMPO04BRS727",
            collabrixCampaignID: 6,
            campaignStatus: "In-Progress",
            stages: [
              {
                stageId: "Stage A",
                stageName: "Stage A (BMT-901423)",
                batches: [
                  { batchNumber: "DBSZA25001", batchId: "DBSZA25001" },
                  { batchNumber: "DBSZA25002", batchId: "DBSZA25002" },
                  { batchNumber: "DBSZA26001", batchId: "DBSZA26001" },
                  { batchNumber: "DBSZA26002", batchId: "DBSZA26002" },
                  { batchNumber: "DBSZA26003", batchId: "DBSZA26003" },
                  { batchNumber: "DBSZA26004", batchId: "DBSZA26004" },
                  { batchNumber: "DBSZA26005", batchId: "DBSZA26005" },
                  { batchNumber: "DBSZA26006", batchId: "DBSZA26006" },
                  { batchNumber: "DBSZA26007", batchId: "DBSZA26007" },
                  { batchNumber: "DBSZA26008", batchId: "DBSZA26008" },
                  { batchNumber: "DBSZA26009", batchId: "DBSZA26009" },
                ],
              },
              {
                stageId: "Stage B",
                stageName: "Stage B (BMT-901424)",
                batches: [
                  { batchNumber: "DBSZ-B26001", batchId: "DBSZ-B26001" },
                  { batchNumber: "DBSZB25001", batchId: "DBSZB25001" },
                  { batchNumber: "DBSZB26001", batchId: "DBSZB26001" },
                  { batchNumber: "DBSZB26002", batchId: "DBSZB26002" },
                  { batchNumber: "DBSZB26003", batchId: "DBSZB26003" },
                  { batchNumber: "DBSZB26004", batchId: "DBSZB26004" },
                  { batchNumber: "DBSZB26005", batchId: "DBSZB26005" },
                  { batchNumber: "DBSZB26006", batchId: "DBSZB26006" },
                  { batchNumber: "DBSZB26007", batchId: "DBSZB26007" },
                ],
              },
              {
                stageId: "Stage C",
                stageName: "Stage C (BMT-901425)",
                batches: [
                  { batchNumber: "DBSZC26001", batchId: "DBSZC26001" },
                  { batchNumber: "DBSZC26002", batchId: "DBSZC26002" },
                  { batchNumber: "DBSZC26003", batchId: "DBSZC26003" },
                  { batchNumber: "DBSZC26004", batchId: "DBSZC26004" },
                  { batchNumber: "DBSZC26005", batchId: "DBSZC26005" },
                  { batchNumber: "DBSZC26006", batchId: "DBSZC26006" },
                ],
              },
              {
                stageId: "Stage D",
                stageName: "Stage D (BMT-897624)",
                batches: [
                  { batchNumber: "DBSZD26001", batchId: "DBSZD26001" },
                  { batchNumber: "DBSZD26002", batchId: "DBSZD26002" },
                  { batchNumber: "DBSZD26003", batchId: "DBSZD26003" },
                  { batchNumber: "DBSZD26004", batchId: "DBSZD26004" },
                  { batchNumber: "DBSZD26005", batchId: "DBSZD26005" },
                  { batchNumber: "DBSZD26006", batchId: "DBSZD26006" },
                ],
              },
            ],
          },
        ],
      },
    },
  ];
};

const getStaticQuickSummary = () => {
  // Count projects by status from static data
  const projects = getStaticProjects();
  const ongoing = projects.filter(p => p.projectStatus === 'In-Progress' || p.campaignStatus === 'Ongoing').length;
  const inactive = projects.filter(p => p.projectStatus === 'Created' || p.campaignStatus === 'Inactive').length;
  const requiredAction = projects.filter(p => p.projectStatus === 'Initiated' || p.campaignStatus === 'Pending').length;
  const delayed = projects.filter(p => p.projectStatus === 'On-Hold' || p.campaignStatus === 'Delayed').length;
  const completed = projects.filter(p => p.projectStatus === 'Completed' || p.campaignStatus === 'Complete').length;
  
  return [
    { statusName: 'Ongoing Projects', count: ongoing },
    { statusName: 'Inactive Projects', count: inactive },
    { statusName: 'Required Action', count: requiredAction },
    { statusName: 'Delayed Projects', count: delayed },
    { statusName: 'Completed Projects', count: completed },
  ];
};

export const fetchProjectsAPI = async (params = {}, cmoSitesList = [], deliverableTypesList = []) => {
  console.log('[Dashboard] Fetching projects with params:', params);

  // Static demo data (live-env branch). On the test branch USE_STATIC_PD_DATA=false, so this is
  // skipped and the live /fetchProjectDashboard path below runs — surfacing real campaigns / stages /
  // batches (including BMR-ingested ones) from the ledger.
  if (USE_STATIC_PD_DATA) {
    const allProjects = getStaticProjects();
    const statusFilterMap = {
      'Ongoing Projects':   p => p.projectStatus === 'In-Progress' || p.campaignStatus === 'Ongoing',
      'Inactive Projects':  p => p.projectStatus === 'Created'     || p.campaignStatus === 'Inactive',
      'Required Action':    p => p.projectStatus === 'Initiated'   || p.campaignStatus === 'Pending',
      'Delayed Projects':   p => p.projectStatus === 'On-Hold'     || p.campaignStatus === 'Delayed',
      'Completed Projects': p => p.projectStatus === 'Completed'   || p.campaignStatus === 'Complete',
    };
    const filterFn = params.projectStatusID && statusFilterMap[params.projectStatusID];
    const filteredProjects = filterFn ? allProjects.filter(filterFn) : allProjects;

    return {
      status: true,
      projects: filteredProjects,
      totalProjects: filteredProjects.length,
    };
  }

  try {
    // Site filter is sourced from fetchMfgPlants: each plant carries
    // mfgPlantShortName (the Site name) and vendorMosymphonyID (the CMO it
    // belongs to). The filter section resolves the selection into two clean
    // payload-ready values, so no list lookup is needed here:
    //   params.cmoOrgId -> cdmoOrgID (the CMO's vendorMosymphonyID, or "all")
    //   params.cmoSite  -> cmoSite   (the mfgPlantShortName, or "all")
    const getCdmoOrgID = (value) =>
      value != null && value !== '' && value !== 'all' ? value : 'all';
    const getCmoSiteName = (value) =>
      value != null && value !== '' && value !== 'all' ? value : 'all';

    // Helper function to convert deliverableType text to ID or "all"
    const getDeliverableTypeID = (deliverableTypeText) => {
      if (!deliverableTypeText || deliverableTypeText === 'all') return 'all';
      // If deliverableTypesList contains objects, find the matching one
      const matched = deliverableTypesList.find(type => {
        if (typeof type === 'object' && type?.deliverableTypeName) {
          return type.deliverableTypeName === deliverableTypeText;
        }
        return type === deliverableTypeText;
      });
      // Return deliverableTypeID if found, otherwise try to parse as number
      if (matched && typeof matched === 'object' && matched.deliverableTypeID) {
        return matched.deliverableTypeID;
      }
      // If it's already a number, return it
      const numValue = Number(deliverableTypeText);
      return isNaN(numValue) ? 'all' : numValue;
    };

    // Build payload for fetchProjectDashboard API (per contract).
    // Contract request: { cdmoOrgID, cmoSite, viewProjectOption, searchByField,
    //                     searchvalue, pageNumber, pageSize }
    //   cdmoOrgID -> resolved site ID (vendorMosymphonyID) or "all"
    //   cmoSite   -> selected site name text or "all"
    // When "all" is selected, send "all" string.
    // viewProjectOption maps the quick-summary tile selection to the contract
    // values: "Completed", "Inactive", "Pending" (action-required tile),
    // "Ongoing", "Delayed".
    // Map the selected Quick Summary tile to the contract viewProjectOption value.
    // The tile passes its statusName (e.g. "Ongoing Projects", "Required Action"),
    // so map those directly. Falls back to "all" when no tile is selected.
    const getViewProjectOption = (value) => {
      if (!value) return 'all';
      if (typeof value === 'string') {
        const tileMap = {
          'Ongoing Projects': 'Ongoing',
          'Inactive Projects': 'Inactive',
          'Required Action': 'Pending',
          'Delayed Projects': 'Delayed',
          'Completed Projects': 'Completed',
        };
        // Tile name, else an already-mapped contract value, else "all".
        if (tileMap[value]) return tileMap[value];
        if (['Ongoing', 'Inactive', 'Pending', 'Delayed', 'Completed'].includes(value)) return value;
        return 'all';
      }
      // Legacy: array of numeric status ids.
      if (Array.isArray(value)) {
        if (value.includes(1)) return 'Ongoing';
        if (value.includes(2)) return 'Inactive';
        if (value.includes(3)) return 'Pending';
        if (value.includes(4)) return 'Delayed';
        if (value.includes(5)) return 'Completed';
      }
      return 'all';
    };

    const payload = {
      cdmoOrgID: getCdmoOrgID(params.cmoOrgId),
      cmoSite: getCmoSiteName(params.cmoSite),
      searchByField: params.searchCriteria && params.searchCriteria !== 'all' ? params.searchCriteria : null,
      searchvalue: params.searchValue || null,
      viewProjectOption: getViewProjectOption(params.projectStatusID),
      // Send exactly what the caller provided when the field is present (so the
      // Document Repository popup can pass empty strings to fetch all, without
      // pagination); default to 10/1 only when the field is omitted entirely.
      pageSize: params.pageSize !== undefined ? params.pageSize : 10,
      pageNumber: params.pageNumber !== undefined ? params.pageNumber : 1,
    };

    console.log('[Dashboard] Project Dashboard API Payload:', payload);

    const apiBaseUrl = getApiBaseUrl(appUrl);
    const response = await axios.post(`${apiBaseUrl}/fetchProjectDashboard`, payload);
    
    // Contract response: { status, data: { totalNoOfRecords, noOfPages, projectsList: [ ... ] } }
    // Also tolerate legacy shapes:
    //   Middleware: { status, data: { data: [ ... ] } }
    //   Corda:      { status, statusCode, data: [ ... ] }
    const rawData =
      (response?.data?.data && Array.isArray(response.data.data.projectsList) && response.data.data.projectsList) ||
      (Array.isArray(response?.data?.projectsList) && response.data.projectsList) ||
      (response?.data?.data && Array.isArray(response.data.data.data) && response.data.data.data) ||
      (response?.data?.data && Array.isArray(response.data.data) && response.data.data) ||
      (Array.isArray(response?.data?.data) && response.data.data) ||
      (Array.isArray(response?.data) && response.data) ||
      [];

    // Pagination metadata from the contract response (when present).
    const totalNoOfRecords =
      response?.data?.data?.totalNoOfRecords ??
      response?.data?.totalNoOfRecords ??
      null;

    if (response?.data?.status && Array.isArray(rawData)) {
      // Map API response to dashboard format
      const projects = rawData.map(project => {
        // Derive PO number: prefer top-level, else from first campaign that has one.
        // Contract uses `campaignsList`; tolerate legacy `campaigns`.
        const campaignsArray = project.campaignsList || project.campaigns || [];
        const campaignWithPo = campaignsArray.find(c => c?.poNumber);
        const derivedPoNumber = project.poNumber || (campaignWithPo ? campaignWithPo.poNumber : '');

        // Site column value: the contract carries `cmoSite` under each campaign
        // (campaignsList[].cmoSite, e.g. "PatheonTRO" / "Unit-IV"), not at the
        // project level. Prefer a project-level value if present, else the first
        // campaign that carries a site.
        const campaignWithSite = campaignsArray.find(c => c?.cmoSite);
        const derivedCmoSite = project.cmoSite || (campaignWithSite ? campaignWithSite.cmoSite : '');

        // Collapsed-row columns (Contracted Qty / UoM / Start / Expected End)
        // come from the first campaign — the same one whose campaignID drives
        // the Campaign ID column. Contract fields: productQuantityRequired, uom,
        // campaignStartDate, campaignEndDate.
        const firstCampaign = campaignsArray[0] || {};

        // Derive deliverable type display value (supporting multiple types)
        let derivedDeliverableType = '';

        // 1) If API already sends a human-readable deliverableType, prefer it
        if (project.deliverableType) {
          derivedDeliverableType = project.deliverableType;
        } else if (Array.isArray(project.deliverableTypes) && project.deliverableTypes.length > 0) {
          // 2) If API sends an array of deliverableTypes, join their names
          const names = project.deliverableTypes
            .map(dt => dt?.deliverableTypeName || dt?.deliverableType || dt)
            .filter(Boolean);
          derivedDeliverableType = names.join(', ');
        } else if (project.deliverableTypeIDs && Array.isArray(deliverableTypesList) && deliverableTypesList.length > 0) {
          // 3) If we only have IDs, map them to names using deliverableTypesList
          const idToNameMap = {};
          deliverableTypesList.forEach(dt => {
            if (dt?.deliverableTypeID != null && dt?.deliverableTypeName) {
              idToNameMap[String(dt.deliverableTypeID)] = dt.deliverableTypeName;
            }
          });

          const ids = String(project.deliverableTypeIDs)
            .split(',')
            .map(id => id && id.trim())
            .filter(Boolean);

          const names = ids
            .map(id => idToNameMap[id])
            .filter(Boolean);

          derivedDeliverableType = names.join(', ');
        }

        // Transform campaigns structure to match UI expectations.
        // Contract: campaignsList -> campaignStageList -> batchesList
        //   (legacy campaignStageDetails / deliveryScheduleBatches tolerated).
        const transformedCampaigns = campaignsArray.map(campaign => {
          const stageArray = campaign.campaignStageList || campaign.campaignStageDetails || [];
          const stages = stageArray.map(stageDetail => {
            const batchArray = stageDetail.batchesList || stageDetail.deliveryScheduleBatches || [];
            // Contract batch: { collabrixBatchID, vendorBatchNumber, batchStartDate,
            //                   batchEndDate, statusDescription }
            const batches = batchArray.map(batch => ({
              batchNumber: batch.vendorBatchNumber || batch.batchNumber || '',
              // collabrixBatchID is what the batch-detail tab APIs key on.
              batchId: batch.collabrixBatchID || batch.schrockenDeliveryScheduleBatchID || batch.batchID || null,
              collabrixBatchID: batch.collabrixBatchID || null,
              // Batch Status column reads batch.batchStatus; contract field is
              // statusDescription (e.g. "Closed" / "New").
              batchStatus: batch.statusDescription || batch.batchStatus || '',
              // Include other batch properties if needed
              ...batch,
            }));

            // "CMO Stage (Chemical No.)" — the chemical number is the stage's
            // product description (sponsor's, falling back to the CMO's).
            const stageChemicalNo =
              stageDetail.sponsorStageProductDescription
              || stageDetail.cmoStageProductDescription
              || '';
            const stageIdValue = stageDetail.cmoStageID || stageDetail.stageNumber || '';

            return {
              stageId: stageIdValue,
              stageName: `${stageDetail.cmoStageID || ''}${stageChemicalNo ? ` (${stageChemicalNo})` : ''}`,
              collabrixCampaignStageID: stageDetail.collabrixCampaignStageID || null,
              batches: batches,
              // Include other stage properties if needed
              ...stageDetail,
            };
          });

          return {
            campaignId: campaign.campaignID || '',
            campaignID: campaign.campaignID || '', // Keep both for compatibility
            collabrixCampaignID: campaign.collabrixCampaignID || null,
            campaignStatus: campaign.campaignStatus || '',
            poNumber: campaign.poNumber || '',
            cmoSite: campaign.cmoSite || '',
            stages: stages,
            // Include other campaign properties
            ...campaign,
          };
        });

        // Contract project fields: collabrixProjectID, sponsorProjectID, cmoProjectID,
        // productCode, productDescription, cmoProductCode, vendorMosymphonyID, projectStatus.
        const projectIdentifier =
          project.collabrixProjectID ?? project.projectID ?? null;

        // Project ID column display = productCode-sponsorProjectID-cmoProductCode
        // (e.g. "1463268-Clinical Supply-BST"). The last part is the CMO PRODUCT
        // code, not the CMO project id. Skip empty parts so we never render
        // stray dashes. When none of the three compose a value, fall back to
        // collabrixProjectID; if that is also missing, leave it blank (no PO
        // fallback).
        const projectDisplayId =
          [project.productCode, project.sponsorProjectID, project.cmoProductCode]
            .map((v) => (v != null && v !== '' ? String(v).trim() : ''))
            .filter(Boolean)
            .join('-') ||
          '';

        return {
          id: projectIdentifier,
          collabrixProjectID: project.collabrixProjectID ?? project.projectID ?? null,
          sponsorProjectID: project.sponsorProjectID || '',
          cmoProjectID: project.cmoProjectID || '',
          productCode: project.productCode || '',
          cmoProductCode: project.cmoProductCode || '',
          vendorMosymphonyID: project.vendorMosymphonyID ?? project.cdmoOrgID ?? '',
          // Site column → campaign-level cmoSite (see derivedCmoSite above).
          // Do not fall back to cdmoOrgID here (that is a numeric org id, not a
          // display name); cmoOrgID is still exposed separately below.
          cmoSite: derivedCmoSite || '',
          cmoOrgID: project.cdmoOrgID || '',
          cmoOrgName: project.cdmoOrgName || '',
          projectId: (projectIdentifier != null ? projectIdentifier.toString() : '') || derivedPoNumber,
          // Combined display value for the Project ID column.
          projectDisplayId,
          productDescription: project.productDescription || '',
          poNumber: derivedPoNumber,
          campaignId: transformedCampaigns?.[0]?.campaignId || '',
          cmoStage: transformedCampaigns?.[0]?.stages?.[0]?.stageId || '',
          cmoBatchNumber: transformedCampaigns?.[0]?.stages?.[0]?.batches?.map(b => b.batchNumber).join(', ') || '',
          // Show a comma-separated list of deliverable type names when available
          deliverableType: derivedDeliverableType,
          projectStatus: project.projectStatus || '',
          campaignStatus: transformedCampaigns?.[0]?.campaignStatus || '',
          completionDate: project.completionDate || '',
          // Collapsed-row columns sourced from the first campaign.
          contractedQty: firstCampaign.productQuantityRequired ?? '',
          uom: firstCampaign.uom || '',
          startDate: firstCampaign.campaignStartDate || '',
          expectedEndDate: firstCampaign.campaignEndDate || '',
          projectDetails: {
            campaigns: transformedCampaigns,
          },
          // Spread any additional project-level properties from API
          ...project,
        };
      });

      return {
        status: true,
        projects: projects,
        // Use the contract's total record count for pagination when provided,
        // otherwise fall back to the number of projects on this page.
        totalProjects: totalNoOfRecords != null ? totalNoOfRecords : projects.length,
      };
    }

    return {
      status: false,
      projects: [],
      totalProjects: 0,
    };
  } catch (error) {
    console.error('[Dashboard] Error fetching projects:', error);
    return {
      status: false,
      projects: [],
      totalProjects: 0,
    };
  }
};

export const getQuickSummaryStatuses = async (filters = {}, cmoSitesList = [], deliverableTypesList = []) => {
  console.log('[Dashboard] Fetching quick summary tiles with filters:', filters);

  // Static demo tiles (live-env branch). On the test branch (USE_STATIC_PD_DATA=false) this is
  // skipped and the live /fetchProjectQuickSummaryTiles path below runs.
  if (USE_STATIC_PD_DATA) {
    return {
      status: true,
      quickSummaryStatuses: getStaticQuickSummary(),
    };
  }

  try {
    const appName = localStorage.getItem("appName");
    const network = localStorage.getItem("network");
    const collabType = localStorage.getItem("collabType");
    const roleName = localStorage.getItem("roleName");

    if (!appName || !network || !collabType || !roleName) {
      throw new Error("Missing required localStorage values for API call");
    }

    const apiBaseUrl = `${appUrl}/${appName}/${network}/${collabType}/${roleName}`;

    // Site filter is sourced from fetchMfgPlants (mfgPlantShortName = Site,
    // vendorMosymphonyID = CMO). The filter section resolves the selection into
    // two payload-ready values, so no list lookup is needed here:
    //   filters.cmoOrgId -> cdmoOrgID (the CMO's vendorMosymphonyID, or "all")
    //   filters.cmoSite  -> cmoSite   (the mfgPlantShortName, or "all")
    const getCdmoOrgID = (value) =>
      value != null && value !== '' && value !== 'all' ? value : 'all';
    const getCmoSiteName = (value) =>
      value != null && value !== '' && value !== 'all' ? value : 'all';

    // Build payload for fetchProjectQuickSummaryTiles API.
    // Contract request: { cdmoOrgID, cmoSite }
    // UI-PD-Changes: Deliverable Type filter removed from the UI, so
    // deliverableTypeID is no longer sent.
    const payload = {
      cdmoOrgID: getCdmoOrgID(filters.cmoOrgId),
      cmoSite: getCmoSiteName(filters.cmoSite),
    };

    console.log('[Dashboard] Quick Summary API Payload:', payload);

    const response = await axios.post(`${apiBaseUrl}/fetchProjectQuickSummaryTiles`, payload);

    if (response?.data?.status === true || response?.data?.status === "true") {
      const data = response.data?.data || {};
      
      // Map API response to expected format
      const quickSummaryStatuses = [
        { statusName: 'Ongoing Projects', count: data.onGoingProjects || 0 },
        { statusName: 'Inactive Projects', count: data.projectsInActive || 0 },
        { statusName: 'Required Action', count: data.projectsRequiredAction || 0 },
        { statusName: 'Delayed Projects', count: data.projectsDelayed || 0 },
        { statusName: 'Completed Projects', count: data.projectsCompleted || 0 },
      ];

      return {
        status: true,
        quickSummaryStatuses: quickSummaryStatuses,
      };
    }

    // Fallback to empty data if API fails
    return {
      status: false,
      quickSummaryStatuses: [
        { statusName: 'Ongoing Projects', count: 0 },
        { statusName: 'Inactive Projects', count: 0 },
        { statusName: 'Required Action', count: 0 },
        { statusName: 'Delayed Projects', count: 0 },
        { statusName: 'Completed Projects', count: 0 },
      ],
    };
  } catch (error) {
    console.error('[Dashboard] Error fetching quick summary tiles:', error);
    // Return empty data on error
    return {
      status: false,
      quickSummaryStatuses: [
        { statusName: 'Ongoing Projects', count: 0 },
        { statusName: 'Inactive Projects', count: 0 },
        { statusName: 'Required Action', count: 0 },
        { statusName: 'Delayed Projects', count: 0 },
        { statusName: 'Completed Projects', count: 0 },
      ],
    };
  }
};

export const updateProjectAndCampaignStatus = async (params = {}) => {
  // Persist project and/or campaign status via njm -> Corda (status-only update).
  // params: { statusType: 'PROJECT'|'CAMPAIGN'|'BOTH', projectId, projectStatus, campaignId, campaignStatus }
  const apiBaseUrl = getApiBaseUrl(appUrl);
  const response = await axios.post(`${apiBaseUrl}/updateProjectAndCampaignStatus`, params);
  return response.data;
};

export const fetchActiveBatchesAPI = async (params = {}) => {
  console.log('[Dashboard] Fetching active batches (mock) with params:', params);

  // Real API (to enable later):
  // Method: POST
  // Endpoint: /fetchActiveBatchesAPI
  // Payload example:
  // {
  //   cmoSite: "Sai - HYD",
  //   deliverableType: "Manufacturing"
  // }
  //
  // const response = await axios.post(`${apiBaseUrl}/fetchActiveBatchesAPI`, {
  //   cmoSite: params.cmoSite,
  //   deliverableType: params.deliverableType,
  // });
  // return response.data;

  // Active batches data intentionally cleared — the previous static data
  // (from BMS_Data_Final_27032026.xlsx) was outdated. Returns empty so the
  // modal shows "No active batches found" until the API is integrated.
  return {
    status: true,
    message: 'Active batches fetched successfully',
    data: {
      activeBatches: [],
    },
  };
};


